var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationModal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 24 25",
    fill: "#B20235",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.606689C5.37188 0.606689 0 5.97857 0 12.6067C0 19.2348 5.37188 24.6067 12 24.6067C18.6281 24.6067 24 19.2348 24 12.6067C24 5.97857 18.6281 0.606689 12 0.606689ZM12 22.3567C6.62344 22.3567 2.25 17.9828 2.25 12.6067C2.25 7.2306 6.62344 2.85669 12 2.85669C17.3766 2.85669 21.75 7.2306 21.75 12.6067C21.75 17.9828 17.3766 22.3567 12 22.3567ZM13.875 16.3567H13.125V12.2317C13.125 11.6129 12.6234 11.1067 12 11.1067H10.5C9.88125 11.1067 9.375 11.6129 9.375 12.2317C9.375 12.8504 9.88125 13.3567 10.5 13.3567H10.875V16.3567H10.125C9.50625 16.3567 9 16.8629 9 17.4817C9 18.1004 9.50625 18.6067 10.125 18.6067H13.875C14.4961 18.6067 15 18.1028 15 17.4817C15 16.8606 14.4984 16.3567 13.875 16.3567ZM12 9.60669C12.8283 9.60669 13.5 8.93497 13.5 8.10669C13.5 7.27841 12.8283 6.60669 12 6.60669C11.1717 6.60669 10.5 7.277 10.5 8.10669C10.5 8.93638 11.1703 9.60669 12 9.60669Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationModal);
export default __webpack_public_path__ + "static/media/InformationModal.bbabcfbbfe30b23ae0af93292e5e16b3.svg";
export { ForwardRef as ReactComponent };